import React from 'react';
import DatePicker from 'react-datepicker';
import styles from './QrAnalytics.module.css';

export default function QrAnalytics({
    analytics,
    isLoading,
    startDate,
    endDate,
    setStartDate,
    setEndDate,
}) {
    const handleClearDates = () => {
        setStartDate(null);
        setEndDate(null);
    };

    const genderLabel = (key) => {
        switch (key) {
            case 'male': return 'Мужчины';
            case 'female': return 'Женщины';
            default: return 'Не указан';
        }
    };

    const formatDateTime = (ms) => {
        if (!ms) return '—';
        const d = new Date(ms);
        const pad = (n) => (n < 10 ? `0${n}` : n);
        return `${pad(d.getDate())}.${pad(d.getMonth() + 1)}.${d.getFullYear()} ${pad(d.getHours())}:${pad(d.getMinutes())}`;
    };

    const fullName = (u) => `${u.first_name || ''} ${u.last_name || ''}`.trim() || '—';

    return (
        <div className={styles.container}>
            <h2 className={styles.title}>QR аналитика</h2>

            <div className={styles.datePickerRow}>
                <div className={styles.datePickers}>
                    <DatePicker
                        selected={startDate}
                        onChange={date => setStartDate(date)}
                        selectsStart
                        startDate={startDate}
                        endDate={endDate}
                        dateFormat="dd.MM.yyyy"
                        placeholderText="От"
                        className={styles.datePicker}
                    />
                    <span className={styles.dateSeparator}>—</span>
                    <DatePicker
                        selected={endDate}
                        onChange={date => setEndDate(date)}
                        selectsEnd
                        startDate={startDate}
                        endDate={endDate}
                        minDate={startDate}
                        dateFormat="dd.MM.yyyy"
                        placeholderText="До"
                        className={styles.datePicker}
                    />
                </div>
                {(startDate || endDate) && (
                    <button className={styles.clearButton} onClick={handleClearDates}>
                        Очистить
                    </button>
                )}
            </div>

            {isLoading ? (
                <div className={styles.loading}>Загрузка...</div>
            ) : !analytics ? (
                <div className={styles.noData}>Нет данных</div>
            ) : (
                <>
                    <div className={styles.statsGrid}>
                        <div className={styles.statCard}>
                            <div className={styles.statValue}>{analytics.page_views || 0}</div>
                            <div className={styles.statLabel}>Переходы по QR</div>
                        </div>
                        <div className={styles.statCard}>
                            <div className={styles.statValue}>{analytics.registrations || 0}</div>
                            <div className={styles.statLabel}>Зарегистрировались</div>
                        </div>
                        <div className={styles.statCard}>
                            <div className={styles.statValue}>{analytics.not_registered || 0}</div>
                            <div className={styles.statLabel}>Не зарегистрировались</div>
                        </div>
                        <div className={styles.statCard}>
                            <div className={styles.statValue}>{analytics.wallet_adds || 0}</div>
                            <div className={styles.statLabel}>Добавили карту в wallet</div>
                        </div>
                    </div>

                    {analytics.gender_breakdown && Object.keys(analytics.gender_breakdown).length > 0 && (
                        <div className={styles.genderSection}>
                            <h3 className={styles.sectionTitle}>Сегментация по полу</h3>
                            <div className={styles.genderGrid}>
                                {Object.entries(analytics.gender_breakdown).map(([key, value]) => (
                                    <div key={key} className={styles.genderCard}>
                                        <div className={styles.genderValue}>{value}</div>
                                        <div className={styles.genderLabel}>{genderLabel(key)}</div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    )}

                    {analytics.registered_users && analytics.registered_users.length > 0 && (
                        <div className={styles.usersSection}>
                            <h3 className={styles.sectionTitle}>
                                Кто зарегистрировался ({analytics.registered_users.length})
                            </h3>
                            <div className={styles.tableWrapper}>
                                <table className={styles.usersTable}>
                                    <thead>
                                        <tr>
                                            <th>Имя</th>
                                            <th>Телефон</th>
                                            <th>Пол</th>
                                            <th>Дата регистрации</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {analytics.registered_users.map((u) => (
                                            <tr key={u.user_id}>
                                                <td>{fullName(u)}</td>
                                                <td>{u.phone || '—'}</td>
                                                <td>{genderLabel(u.gender)}</td>
                                                <td>{formatDateTime(u.created_at)}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    )}
                </>
            )}
        </div>
    );
}
